// extracted by mini-css-extract-plugin
module.exports = {"confirmEmailWrap":"ConfirmEmail_confirmEmailWrap__1HAnI","title":"ConfirmEmail_title__2Ausg"};